import { useImportedAssetTypes, useReleasedAssetPickerOptions } from './assetSchemaHooks';

// Only offer asset types the module can model (e.g. not Customer).
export const REHAB_PICKER_RULE = { capability: 'Rehab' } as const;
export const DETERIORATION_PICKER_RULE = { capability: 'Deterioration' } as const;

type CapabilityRule = typeof REHAB_PICKER_RULE | typeof DETERIORATION_PICKER_RULE;

/** Picker options released by the schema catalog flag, imported by the tenant and carrying the rule's capability. */
export const usePickerOptions = (rule: CapabilityRule = REHAB_PICKER_RULE) => {
	const imported = useImportedAssetTypes();
	const options = useReleasedAssetPickerOptions({ ...rule, imported });

	return { ...options, retry: imported.retry };
};

/** System types released by the schema catalog flag that the tenant has imported with at least one asset type with the capability. */
export const useSystemTypes = (rule: CapabilityRule = REHAB_PICKER_RULE) => usePickerOptions(rule).systemTypes;
